import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';
import { useAccountsFields } from '@utils/hooks';

import { accountsActions, useStore } from '@modules';

import InputOld from '@components/InputOld';
import AccountDetails from '@containers/AccountDetails';
import AccountTopupLayoutOld from '@layouts/AccountTopupLayoutOld';
import LoaderLayout from '@layouts/LoaderLayout';

import style from './AccountsTopup.scss';

const cn = bemCssModules(style, 'AccountsTopup');

const LIMIT_VALUE = '5,000 EUR';

export const AccountsTopup: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [{ accounts }, dispatch] = useStore();
  const { details, loaders } = accounts;
  const account = details[0];

  useEffect(() => {
    if (!account?.iban) dispatch(accountsActions.getAccounts());
  }, []);

  const { recipient, iban, swiftCode, countryOfResidence, city, address } =
    useAccountsFields(account);

  const fields = [recipient, iban, swiftCode, countryOfResidence, city, address];

  const isLoading = loaders.getAccounts && !account;

  return (
    <AccountTopupLayoutOld className={cn(null, [className])}>
      <LoaderLayout isLoading={isLoading}>
        <InputOld
          label={t('iban.max_limit_transaction')}
          placeholder={LIMIT_VALUE}
          className={cn('limit')}
          withoutBorder
          disabled
        />
        <AccountDetails fields={fields} />
      </LoaderLayout>
    </AccountTopupLayoutOld>
  );
};

export default AccountsTopup;
